import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TabLink = ({ prefix, name, icon, ignoreWith = false, style, onClick = null, text, bold }) => {
  return (
    <li className="nav-item" style={{ listStyle: "none", ...style }}>
      <a
        className={bold ? "nav-link modern-tab-link" : "nav-link"}
        id={prefix + "-" + name + "-tab"}
        data-toggle="pill"
        href={"#" + prefix + "-" + name}
        role="tab"
        aria-controls={prefix + "-" + name}
        aria-selected="false"
        onClick={onClick}
        style={bold ? undefined : {
          display: "flex",
          alignItems: "center",
          gap: "6px",
          padding: "8px 16px",
          borderRadius: "8px 8px 0 0",
          fontSize: "0.88rem",
          fontWeight: 500,
          color: "#616161",
          textDecoration: "none",
          borderBottom: "2px solid transparent",
        }}
      >
        {icon && <FontAwesomeIcon icon={icon} style={{ fontSize: bold ? "0.85rem" : undefined }} />}
        {(window.innerWidth > 1117 || ignoreWith === true) && (
          <span>{typeof text === "undefined" ? name : text}</span>
        )}
      </a>
    </li>
  );
};

export default TabLink;
